<template>
  <div class="principalInformation EOPPBlock">
    <div class="strip"></div>

    <div class="OEName">
      <span class="name" v-if="windowWidth > 900">{{ oe.name }}</span>

      <slot></slot>
    </div>

    <div class="OELogo">
      <img :src="oe.logo" v-if="oe.logo" />

      <img src="../../../assets/img/image.png" v-else />
    </div>

    <div class="OEInfo">
      <div class="OENameMobile" v-if="windowWidth <= 900">{{ oe.name }}</div>

      <div class="OECategory">
        {{ oe.category }} -
        {{
          oe.university && oe.university.search("-") > -1
            ? oe.university.split("-")[0]
            : oe.university
        }}
      </div>

      <div class="OECity">{{ oe.city }} - {{ oe.state }}</div>
      <br />

      <div class="OEEmailMobile" v-if="windowWidth <= 900">
        {{ oe.organizationEmail }}
      </div>
    </div>

    <div class="OEContact">
      <div class="OEEmail" v-if="windowWidth > 900">
        {{ oe.organizationEmail }}
      </div>
      <div class="OESocial">
        <div class="OEface" @click="newAction('facebook')">
          <b-tooltip
            :label="
              oe.fanpage != ''
                ? 'Clique para acessar a página do Facebook da sua OE'
                : 'Clique para inserir o Facebook da sua OE'
            "
          >
            <b-icon
              pack="fab"
              icon="facebook"
              size="is-large"
              :style="oe.fanpage ? 'color: rgb(2,209,168);' : 'color: gray;'"
            ></b-icon>
          </b-tooltip>
        </div>

        <div class="OEinsta" @click="newAction('instagram')">
          <b-tooltip
            :label="
              oe.insta
                ? 'Clique para acessar a página do Instagram da sua OE'
                : 'Clique para inserir o Instagram da sua OE'
            "
          >
            <b-icon
              pack="fab"
              icon="instagram"
              size="is-large"
              :style="oe.insta ? 'color: rgb(2,209,168);' : 'color: gray;'"
            ></b-icon>
          </b-tooltip>
        </div>

        <div class="OELinkedin" @click="newAction('linkedin')">
          <b-tooltip
            :label="
              oe.linkedin
                ? 'Clique para acessar a página do Linkedin da sua OE'
                : 'Clique para inserir o Linkedin da sua OE'
            "
          >
            <b-icon
              pack="fab"
              icon="linkedin"
              size="is-large"
              :style="oe.linkedin ? 'color: rgb(2,209,168);' : 'color: gray;'"
            ></b-icon>
          </b-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { responsive } from "../../../mixins/responsive";

export default {
  name: "MainInfo",

  mixins: [responsive],

  props: ["oe"],

  methods: {
    openModal() {
      this.$parent.formMainInfoActive = true;
    },
    newAction(name) {
      if (name == "facebook") {
        if (this.oe.fanpage) {
          window.open(this.oe.fanpage);
        } else {
          this.openModal();
        }
      }
      if (name == "instagram") {
        if (this.oe.insta) {
          window.open(this.oe.insta);
        } else {
          this.openModal();
        }
      }
      if (name == "linkedin") {
        if (this.oe.linkedin) {
          window.open(this.oe.linkedin);
        } else {
          this.openModal();
        }
      }
    }
  }
};
</script>

<style scoped>
.EOPPBlock {
  border: solid 0.5px rgb(175, 175, 175);
  border-radius: 0.5rem;
}
.strip {
  height: 0.5rem;
  background: rgb(2, 209, 168);
  background: linear-gradient(
    90deg,
    rgba(2, 209, 168, 1) 0%,
    rgba(95, 255, 223, 1) 100%,
    rgba(60, 247, 210, 1) 100%
  );
  border-radius: 0.5rem 0.5rem 0 0;
}
.OEName {
  background-image: url("../../../assets/img/headerPerfil.jpg");
  min-height: 10rem;
  display: flex;
}
.OEName .name {
  color: white;
  font-size: 3rem;
  font-weight: 800;
  width: fit-content;
  display: block;
  margin-left: 47%;
  padding-top: 4rem;
}
.OELogo {
  border: solid 0.5px rgb(175, 175, 175);
  border-radius: 50%;
  width: 15rem;
  height: 15rem;
  margin-top: -7.5rem;
  margin-left: 10%;
  background-color: white;
}
.OELogo img {
  border-radius: 50%;
  width: 15rem;
  height: 15rem;
  background-color: white;
  margin: auto;
  display: block;
}
.OEInfo {
  color: black;
  width: 45%;
  min-width: 25rem;
  margin-top: -6rem;
  margin-left: 47%;
}
.OECategory {
  font-size: 1.8rem;
  font-weight: 700;
}
.OECity {
  font-size: 1.4rem;
}
.OEContact {
  display: grid;
  grid-template-columns: auto auto;
  border: solid 0.5px;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-top-color: rgb(175, 175, 175);
  margin-top: 2rem;
  height: 5rem;
}
.OEEmail {
  display: flex;
  margin: auto;
  color: black;
  font-size: 1.2rem;
}

.OESocial {
  display: flex;
  width: fit-content;
  margin: auto;
  cursor: pointer;
}

@media (max-width: 900px) {
  .OEName {
    min-height: 6rem;
  }
  .OELogo {
    width: 9rem;
    height: 9rem;
    margin-left: auto;
    margin-right: auto;
    margin-top: -5rem;
  }

  .OELogo img {
    width: 9rem;
    height: 9rem;
    margin-left: auto;
    margin-right: auto;
  }

  .OEInfo {
    margin-top: 0rem;
    margin-left: auto;
    margin-right: auto;
  }
  .OENameMobile {
    font-size: 1.8rem;
    font-weight: 700;
    text-align: center;
  }
  .OECategory {
    font-size: 1.6rem;
    font-weight: 600;
    text-align: center;
  }
  .OECity {
    text-align: center;
  }
  .OEEmailMobile {
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
  }
  .OEContact {
    grid-template-columns: auto;
  }
}

@media (max-width: 500px) {
  .OEInfo {
    width: fit-content;
    min-width: 10rem;
  }
  .OENameMobile {
    font-size: 1.6rem;
  }
  .OECategory {
    font-size: 1.3rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .OECity {
    font-size: 1.2rem;
  }
}
</style>
